module.exports = __webpack_public_path__ + "media/home_bg.f47b61b2.mp4";